import axios from 'axios'
import Moment from 'moment'
import config from '../config'

const compareDates = (a, b) => {
  if (Moment.utc(a).isBefore(b)) {
    return -1
  } else if (Moment.utc(a).isAfter(b)) {
    return 1
  }
  return 0
};

const sortById = (a, b) => {
  if (a.id < b.id) {
    return -1
  } else if (a.id > b.id) {
    return 1
  }
  return 0
};

const sortByName = (a, b) => {
  if (a.name < b.name) {
    return -1
  } else if (a.name > b.name) {
    return 1
  }
  return 0
};

const getFilms = (type, soon = false) => {
  let url = '';
  if (type === 'client') {
    url = config.client_films_url;
  } else if (type === 'backend') {
    url = config.backend_films_url;
  }
  if (soon) {
    url = url + '?comingSoon=true';
  }
  return new Promise((resolve, reject) => {
    axios.get(url)
      .then(res => {
        const films = res.data;
        const filmsById = {};
        const uniqueDates = new Set();
        const uniqueHalls = {};
        const uniqueHallsArray = [];
        const uniqueFormatsArray = [];
        const uniqueFormats = {};
        // Бежим по всем сеансам всех фильмов
        for (let film of films) {
          for (let session of film.Sessions) {
            // формируем сет уникальных дат в расписаниее
            uniqueDates.add(Moment.utc(session.ShowTime).format('YYYY-MM-DD'));
            // уникальные залы / форматы делаем через объект
            uniqueHalls[session.hall_number] = {id: session.hall_number, name: session.hall_name};
            for (let attr of session.attributes) {
              if (attr.type === 'format') {
                uniqueFormats[attr.type + '-' + attr.short_name] = attr;
              }
            }
          }
          // Формируем справочник фильмов по ID - понадобится для страницы фильма
          filmsById[film.Id] = film;
        }
        // Формируем справочник залов
        Object.keys(uniqueHalls).forEach(hallid => {
          uniqueHallsArray.push(uniqueHalls[hallid]);
        });
        uniqueHallsArray.sort(sortById);
        // Формируем справочник форматов
        Object.keys(uniqueFormats).forEach(formatKey => {
          uniqueFormats[formatKey].id = formatKey;
          uniqueFormatsArray.push(uniqueFormats[formatKey])
        });
        uniqueFormatsArray.sort(sortByName);
        let uniqueDatesArray = Array.from(uniqueDates);
        uniqueDatesArray.sort(compareDates);
        resolve({
          films,
          filmsById,
          scheduleDates: uniqueDatesArray,
          halls: uniqueHallsArray,
          hallsById: uniqueHalls,
          formats: uniqueFormatsArray,
          formatsById: uniqueFormats,
        });
      })
      .catch(err => {
        reject(err);
      });
  });
};

export default getFilms


// WEBPACK FOOTER //
// ./src/api-helpers/getFilms.js